import { render } from "./AdvertisingPage.vue?vue&type=template&id=63403210&scoped=true"
import script from "./AdvertisingPage.vue?vue&type=script&lang=js"
export * from "./AdvertisingPage.vue?vue&type=script&lang=js"

import "./AdvertisingPage.vue?vue&type=style&index=0&id=63403210&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63403210"]])

export default __exports__